module.exports = __webpack_public_path__ + "5077d222300d31fbb9d29dfbb0b04e66.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/violin-s.png
// module id = 2760
// module chunks = 0